import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EditStorageSpaceTypePageNew from "../../components/StorageSpaceType/AddStorageSpaceTypePageNew";



const EditStorageSpaceTypePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Storage Type" link2="/space-type" title="Edit Storage Type" />

        {/* AddUserLayer */}
        <EditStorageSpaceTypePageNew />


      </MasterLayout>
    </>
  );
};

export default EditStorageSpaceTypePage;
